import {memo, useContext} from 'react';
import {ChargeBackContext} from "context/ChargeBackContext";

const ChargeBackInfoContent = ({ currentStatus, handleStatusSwitch }) => {
  const { allOrderData  } = useContext(ChargeBackContext);
  return (
    <>
      {handleStatusSwitch(currentStatus, allOrderData?.chargeTotal, allOrderData)}
    </>
  )
}

export default memo(ChargeBackInfoContent)